import type { EventProps, ShipperUser } from './types';

// OpenPanel profile (people) properties. Shared by the web and React Native
// shippers so the PII-bearing profile schema lives in one place and cannot drift.
export const openPanelProfileProperties = (user: ShipperUser): EventProps => ({
  userId: user.id,
  email: user.email,
  phone_number: user.phoneNumber,
  first_name: user.firstName,
  last_name: user.lastName,
  is_worker: Boolean(user.isWorker)
});
